import { styled } from 'styled-components';
import { useSelector } from 'react-redux';

import * as store from '../../../../../reducers/store';

interface Props {
  text: string;
}

const Highlight: React.FC<Props> = ({ text }) => {
  const primaryHexColor: string | undefined = useSelector(
    (store: store.All) => store.theme?.primaryHexColor,
  );
  return (
    <HighlightedSpan $primaryBrandColor={primaryHexColor}>
      {text}
    </HighlightedSpan>
  );
};

export default Highlight;

const HighlightedSpan = styled.span.attrs<{ $primaryBrandColor?: string }>(
  (props) => ({
    $primaryBrandColor:
      props.$primaryBrandColor || 'var(--color-brand-primary)',
  }),
)`
  color: ${(props) => props.$primaryBrandColor};
  font-weight: var(--weight-semi-bold);
  font-size: inherit;
`;
